
const TAREAS_PREDEFINIDAS = [
  'Aumentar a 6 tiempos de comida por día',
  'Aumentar el consumo de fibra diario',
  'Aumentar el consumo de proteína diario',
  'Caminar 30 minutos al día',
  'Dormir mínimo 7-8 horas por noche',
  'Eliminar azúcares añadidos de la dieta',
  'Evitar alimentos ultraprocesados',
  'Evitar bebidas azucaradas y gaseosas',
  'Evitar el tabaco',
  'Incorporar actividad cardiovascular moderada',
  'Realizar rutina de fuerza 3 veces por semana',
  'Reducir el consumo de alcohol',
  'Reducir el consumo de carbohidratos simples',
  'Respetar las 3 comidas principales sin saltarse ninguna',
  'Tomar mínimo 2 litros de agua al día',
  'Tomar omega-3 con las comidas',
  'Tomar proteína en polvo post-entrenamiento',
  'Tomar suplemento de colágeno con el desayuno',
]

const TRATAMIENTOS_PREDEFINIDOS = [
  'Agonista dual de GLP-1',
  'Agonista simple de GLP-1',
  'Agonista triple de GLP-1',
  'Aplicación de bioestimulador',
  'Biotin IV',
  'Depilación láser',
  'Endosphere',
  'Mesoterapia',
  'Profhilo',
  'Protocolo combinado de GLP-1',
  'Relleno con ácido hialurónico',
  'Toxina botulínica',
  'Vitamina C IV',
]

export { TAREAS_PREDEFINIDAS, TRATAMIENTOS_PREDEFINIDOS }
